module.exports = __webpack_public_path__ + "img/festa7.922bc0ae.jpg";